<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="user-list-filters mb-8"
          :collapse-action="true">
          <div class="vx-row">
            <div class="vx-col md:w-1/3 sm:w-1/2 w-full mb-5">
              <label class="text-sm opacity-100 text-bold">General Search</label>
              <vs-input type="text" class="w-full" v-model="filters['search']" />
            </div>
            <div class="vx-col md:w-1/3 sm:w-1/2 w-full mb-5">
              <label class="text-sm opacity-100 text-bold">Expiry Date From</label>
              <flat-pickr class="w-full" :config="{ dateFormat: 'd/m/Y' }" v-model="filters['from']"
                placeholder="Choose Date" />
            </div>
            <div class="vx-col md:w-1/3 sm:w-1/2 w-full mb-5">
              <label class="text-sm opacity-100 text-bold">Expiry Date To</label>
              <flat-pickr class="w-full" :config="{ dateFormat: 'd/m/Y' }" v-model="filters['to']"
                placeholder="Choose Date" />
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full md:w-6/6">
              <div class="btn-group float-right">
                <vs-button color="danger" size="small" @click="onClickClearSearch">Clear</vs-button>
              </div>
            </div>
          </div>
        </vx-card>
        <vx-card title="Supplier Accreditation Expiry Report">
          <template slot="actions">
            <div class="flex">
              <excel-download :name="'supplier-site-accreditation'" :filters="filters"/>
            </div>
          </template>
          <vs-table :max-items="(meta.per_page) ? meta.per_page : 10" stripe :data="mass_balance_data" :sst="true"
            class="table-dark-inverted table-auto vs-con-loading__container" id="mass-balance-audit-table" @sort="handleSort">
            <template slot="thead">
              <vs-th width="15%">CREATED DATE</vs-th>
              <vs-th width="15%" sort-key="expiry">EXPIRY DATE</vs-th>
              <vs-th width="15%">SUPPLIER NAME</vs-th>
              <vs-th width="20%">SITE NAME</vs-th>
              <vs-th width="10%">GRADE</vs-th>
              <vs-th width="5%">TYPE</vs-th>
              <vs-th width="10%">BODY</vs-th>
              <vs-th width="10%">ACTION</vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr @click.native="onClickViewSite(tr.supplier_id, tr.site_id)" style="cursor: pointer" :key="indextr" v-for="(tr, indextr) in data">

                <vs-td>
                  {{ __dateTimeFormatter(tr.created_at) }}
                </vs-td>
                <vs-td>
                  {{ tr.expiry }}
                </vs-td>
                <vs-td>
                  <HyperLink :id="tr.supplier_id" type="supplier">{{ tr.supplier_name }}</HyperLink>
                </vs-td>
                <vs-td>
                  {{ tr.site_name }}
                </vs-td>
                <vs-td>
                  {{ tr.grade }}
                </vs-td>
                <vs-td>
                  {{ tr.type }}
                </vs-td>
                <vs-td>
                  {{ tr.body }}
                </vs-td>
                <vs-td>
                  <div class="vx-row">
                    <vx-tooltip class="text-primary cursor-pointer" text="View" position="left">
                      <vs-button @click.stop="onClickViewSite(tr.supplier_id, tr.site_id)" size="small"
                        icon-pack="feather" icon="icon-eye"></vs-button>
                    </vx-tooltip>
                    <vx-tooltip class="text-primary cursor-pointer" text="Send Expired Reminder" position="left">
                      <vs-button @click.stop="onClickSendEmail(tr.supplier_id, tr.id)" size="small"
                        icon-pack="feather" icon="icon-send" class="ml-2" color="warning"></vs-button>
                    </vx-tooltip>
                  </div>
                </vs-td>
              </vs-tr>
            </template>

          </vs-table>
          <vs-pagination v-on:changeMaxItems="changePage" :size-array="meta.total ? meta.total : 20" :max-items="perPage"
            description-body="Rows per page" description-connector="of" description-title="Records" description
            :description-items="descriptionItems" :total="(meta.last_page) ? meta.last_page : 0" v-model="page"
            class="p-5">
          </vs-pagination>
        </vx-card>
      </div>
    </div>
    <vs-prompt
      @cancel="temp_email=''"
      @accept="sendEmail"
      @close="activePrompt = false"
      :title="'Select customer user email to send'"
      :accept-text="'Confirm'"
      :color="'primary'"
      :active.sync="activePrompt">
      <div class="con-exemple-prompt">
        <span>Select user email</span>
        <v-select
          :clearable="true" name="temp_email" placeholder=""
          v-model="temp_email"
          label="email"
          :options="supplier_users"
          :reduce="option => option.email"
          :dir="$vs.rtl ? 'rtl' : 'ltr'">
          <template v-slot:option="option">
              <span>{{option.email}} ( {{option.first_name || 'N/A'}} ) </span>
          </template>
          </v-select>
      </div>
    </vs-prompt>
  </div>
</template>

<script>

import { RepositoryFactory } from "@/repository/RepositoryFactory";
import { defaultPagination, perPageList } from "@/constants/config";
import flatPickr from "vue-flatpickr-component";
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'
import ErrorMessages from "@/mixins/ErrorMessages";
const ReportingRepository = RepositoryFactory.get('reporting')
const SupplieRepository = RepositoryFactory.get('supplier')
import Filter from '@/mixins/filter';

export default {
  name: "MassBalanceAudit",
  data() {
    return {
      mass_balance_data: [],
      meta: {},
      maxItems: 20,
      page: 1,
      total: 0,
      sort: '',
      perPage: defaultPagination,
      descriptionItems: perPageList,
      filters: {},
      activePrompt: false,
      supplier_users: [],
      temp_acc_id: null,
      temp_email: null
    }
  },
  components: {
    flatPickr,
    'v-select': vSelect,
  },
  mixins: [ErrorMessages, Filter],
  methods: {
    async getMasBalanceReportData() {
      try {
        this.mass_balance_data = []
        await this.$vs.loading()
        const { data } = await ReportingRepository.getSupplierAccreditationReport(this.page, this.filterQuery, this.perPage, this.sort)
        this.mass_balance_data = data.data
        this.meta = data.meta
      } catch (error) {
        this.convertAndNotifyError(error)
      }
      this.$vs.loading.close()
    },
    async onClickClearSearch() {
      this.filters = {
        search: '',
        status: '',
        from_manu_date: '',
        to_manu_date: '',
        from_exp_date: '',
        to_exp_date: '',
      }
      await this.getMasBalanceReportData()
    },
    async onClickViewSite(supplier_id, site_id) {
      let route = this.$router.resolve({ path: `/pages/manage-nimble/suppliers/${supplier_id}/manufacturing/${site_id}` });
      window.open(route.href, '_blank');
    },
    changePage(index) {
      this.page = 1
      this.perPage = this.descriptionItems[index]
    },
    filterQueryUpdate() {
      this.page = 1
      this.getMasBalanceReportData()
    },
    handleSort(key, active) {
        if(key){
          active = (active==='desc')? "-":'';
          this.sort=active+key;
          this.getMasBalanceReportData()
        }
    },
    async onClickSendEmail(supplier_id, id) {
      const { data } = (await SupplieRepository.getSupplierUsers(supplier_id, 1, 50, '')).data
      this.supplier_users = data
      this.temp_acc_id = id
      this.temp_email = null
      this.activePrompt = true
    },
    async sendEmail() {
      await ReportingRepository.sendSupplierAccreditationEmail(this.temp_acc_id, { email: this.temp_email })
      this.activePrompt = false
    }
  },
  watch: {
    page() {
      this.getMasBalanceReportData()
    },
    perPage() {
      this.getMasBalanceReportData()
    }
  }
}
</script>

<style scoped></style>
